import { Plugin } from "ckeditor5/src/core";

export default class SpecialCharactersContent extends Plugin {
  static get pluginName() {
    return "SpecialCharactersContent";
  }

  init() {
    const editor = this.editor;
    const t = editor.t;
    const plugin = editor.plugins.get("SpecialCharacters");

    plugin.addItems("Frequently Used", [
      { title: t("No-break space"), character: "\u00a0" },
      { title: t("En dash"), character: "\u2013" },
      { title: t("Em dash"), character: "\u2014" },
      { title: t("Degree sign"), character: "\u00b0" },
      { title: t("Quotation mark"), character: "\u0022" },
      { title: t("Left single quotation mark"), character: "\u2018" },
      { title: t("Right single quotation mark"), character: "\u2019" },
      { title: t("Left double quotation mark"), character: "\u201C" },
      { title: t("Right double quotation mark"), character: "\u201D" },
      { title: t("Less-than sign"), character: "\u003C" },
      { title: t("Greater-than sign"), character: "\u003E" },
      { title: t("Less-than or equal to"), character: "\u2264" },
      { title: t("Greater-than or equal to"), character: "\u2265" },
      { title: t("Uppercase Curly E"), character: "\u2130" },
      { title: t("Dagger"), character: "\u2020" },
      { title: t("Double dagger"), character: "\u2021" },
      { title: t("Copyright sign"), character: "\u00a9" },
      { title: t("Middle dot"), character: "\u00b7" },
    ]);

    plugin.addItems("Math", [
      { title: t("Circle Arrow Left"), character: "\u21BA" },
      { title: t("Circle Arrow Right"), character: "\u21BB" },
      { title: t("Leftwards arrow"), character: "\u2190" },
      { title: t("Upwards arrow"), character: "\u2191" },
      { title: t("Rightwards arrow"), character: "\u2192" },
      { title: t("Downwards arrow"), character: "\u2193" },
      { title: t("Plus-minus sign"), character: "\u00b1" },
      { title: t("Small tilde"), character: "\u02dc" },
      { title: t("Circumflex accent"), character: "\u005e" },
      { title: t("Minus sign"), character: "\u2212" },
      { title: t("Division sign"), character: "\u00f7" },
      { title: t("Fraction slash"), character: "\u2044" },
      { title: t("Multiplication sign"), character: "\u00d7" },
      { title: t("Function/florin"), character: "\u0192" },
      { title: t("Integral"), character: "\u222b" },
      { title: t("N-ary summation"), character: "\u2211" },
      { title: t("Infinity"), character: "\u221e" },
      { title: t("Square root"), character: "\u221a" },
      { title: t("Similar to"), character: "\u223c" },
      { title: t("Approximately equal to"), character: "\u2245" },
      { title: t("Almost equal to"), character: "\u2248" },
      { title: t("Not equal to"), character: "\u2260" },
      { title: t("Identical to"), character: "\u2261" },
      { title: t("Element of"), character: "\u2208" },
      { title: t("Not an element of"), character: "\u2209" },
      { title: t("Contains as member"), character: "\u220b" },
      { title: t("N-ary product"), character: "\u220f" },
      { title: t("Logical and"), character: "\u2227" },
      { title: t("Logical or"), character: "\u2228" },
      { title: t("Not sign"), character: "\u00ac" },
      { title: t("Intersection"), character: "\u2229" },
      { title: t("Union"), character: "\u222a" },
      { title: t("Partial differential"), character: "\u2202" },
      { title: t("For all"), character: "\u2200" },
      { title: t("There exists"), character: "\u2203" },
      { title: t("Diameter"), character: "\u2205" },
      { title: t("Backward difference"), character: "\u2207" },
      { title: t("Asterisk operator"), character: "\u2217" },
      { title: t("Proportional to"), character: "\u221d" },
      { title: t("Angle"), character: "\u2220" },
      { title: t("Acute accent"), character: "\u00b4" },
      { title: t("Cedilla"), character: "\u00b8" },
      { title: t("Feminine ordinal indicator"), character: "\u00aa" },
      { title: t("Masculine ordinal indicator"), character: "\u00ba" },
      { title: t("Alef symbol"), character: "\u2135" },
      { title: t("Pi symbol"), character: "\u03d6" },
      { title: t("Real part symbol"), character: "\u211c" },
      { title: t("Upsilon - hook symbol"), character: "\u03d2" },
      { title: t("Weierstrass p"), character: "\u2118" },
      { title: t("Imaginary part"), character: "\u2111" },
      { title: t("Left right arrow"), character: "\u2194" },
      { title: t("Carriage return"), character: "\u21b5" },
      { title: t("Leftwards double arrow"), character: "\u21d0" },
      { title: t("Upwards double arrow"), character: "\u21d1" },
      { title: t("Rightwards double arrow"), character: "\u21d2" },
      { title: t("Downwards double arrow"), character: "\u21d3" },
      { title: t("Left right double arrow"), character: "\u21d4" },
      { title: t("Therefore"), character: "\u2234" },
      { title: t("Subset of"), character: "\u2282" },
      { title: t("Superset of"), character: "\u2283" },
      { title: t("Not a subset of"), character: "\u2284" },
      { title: t("Subset of or equal to"), character: "\u2286" },
      { title: t("Superset of or equal to"), character: "\u2287" },
      { title: t("Circled plus"), character: "\u2295" },
      { title: t("Circled times"), character: "\u2297" },
      { title: t("Perpendicular"), character: "\u27c2" },
      { title: t("Dot operator"), character: "\u22c5" },
      { title: t("Left ceiling"), character: "\u2308" },
      { title: t("Right ceiling"), character: "\u2309" },
      { title: t("Left floor"), character: "\u230a" },
      { title: t("Right floor"), character: "\u230b" },
      { title: t("Left-pointing angle bracket"), character: "\u2329" },
      { title: t("Right pointing angle bracket"), character: "\u232a" },
      { title: t("Lozenge"), character: "\u25ca" },
    ]);

    plugin.addItems("Accented/Special Characters", [
      { title: t("A - grave"), character: "\u00c0" },
      { title: t("A - acute"), character: "\u00c1" },
      { title: t("A - circumflex"), character: "\u00c2" },
      { title: t("A - tilde"), character: "\u00c3" },
      { title: t("A - diaeresis"), character: "\u00c4" },
      { title: t("A - ring above"), character: "\u00c5" },
      { title: t("A - macron"), character: "\u0100" },
      { title: t("Ligature AE"), character: "\u00c6" },
      { title: t("C - cedilla"), character: "\u00c7" },
      { title: t("E - grave"), character: "\u00c8" },
      { title: t("E - acute"), character: "\u00c9" },
      { title: t("E - circumflex"), character: "\u00ca" },
      { title: t("E - diaeresis"), character: "\u00cb" },
      { title: t("E - macron"), character: "\u0112" },
      { title: t("I - grave"), character: "\u00cc" },
      { title: t("I - acute"), character: "\u00cd" },
      { title: t("I - circumflex"), character: "\u00ce" },
      { title: t("I - diaeresis"), character: "\u00cf" },
      { title: t("I - macron"), character: "\u012a" },
      { title: t("Eth"), character: "\u00d0" },
      { title: t("N - tilde"), character: "\u00d1" },
      { title: t("O - grave"), character: "\u00d2" },
      { title: t("O - acute"), character: "\u00d3" },
      { title: t("O - circumflex"), character: "\u00d4" },
      { title: t("O - tilde"), character: "\u00d5" },
      { title: t("O - diaeresis"), character: "\u00d6" },
      { title: t("O - slash"), character: "\u00d8" },
      { title: t("O - macron"), character: "\u014c" },
      { title: t("Ligature OE"), character: "\u0152" },
      { title: t("S - caron"), character: "\u0160" },
      { title: t("U - grave"), character: "\u00d9" },
      { title: t("U - acute"), character: "\u00da" },
      { title: t("U - circumflex"), character: "\u00db" },
      { title: t("U - diaeresis"), character: "\u00dc" },
      { title: t("U - macron"), character: "\u016a" },
      { title: t("Y - acute"), character: "\u00dd" },
      { title: t("Y - diaeresis"), character: "\u0178" },
      { title: t("Y - macron"), character: "\u0232" },
      { title: t("Thorn"), character: "\u00de" },
      { title: t("a - grave"), character: "\u00e0" },
      { title: t("a - acute"), character: "\u00e1" },
      { title: t("a - circumflex"), character: "\u00e2" },
      { title: t("a - tilde"), character: "\u00e3" },
      { title: t("a - diaeresis"), character: "\u00e4" },
      { title: t("a - ring above"), character: "\u00e5" },
      { title: t("a - macron"), character: "\u0101" },
      { title: t("Ligature ae"), character: "\u00e6" },
      { title: t("c - cedilla"), character: "\u00e7" },
      { title: t("e - grave"), character: "\u00e8" },
      { title: t("e - acute"), character: "\u00e9" },
      { title: t("e - circumflex"), character: "\u00ea" },
      { title: t("e - diaeresis"), character: "\u00eb" },
      { title: t("e - macron"), character: "\u0113" },
      { title: t("i - grave"), character: "\u00ec" },
      { title: t("i - acute"), character: "\u00ed" },
      { title: t("i - circumflex"), character: "\u00ee" },
      { title: t("i - diaeresis"), character: "\u00ef" },
      { title: t("i - macron"), character: "\u012b" },
      { title: t("eth"), character: "\u00f0" },
      { title: t("n - tilde"), character: "\u00f1" },
      { title: t("o - grave"), character: "\u00f2" },
      { title: t("o - acute"), character: "\u00f3" },
      { title: t("o - circumflex"), character: "\u00f4" },
      { title: t("o - tilde"), character: "\u00f5" },
      { title: t("o - diaeresis"), character: "\u00f6" },
      { title: t("o - slash"), character: "\u00f8" },
      { title: t("o - macron"), character: "\u014d" },
      { title: t("Ligature oe"), character: "\u0153" },
      { title: t("s - caron"), character: "\u0161" },
      { title: t("u - grave"), character: "\u00f9" },
      { title: t("u - acute"), character: "\u00fa" },
      { title: t("u - circumflex"), character: "\u00fb" },
      { title: t("u - diaeresis"), character: "\u00fc" },
      { title: t("u - macron"), character: "\u016b" },
      { title: t("y - acute"), character: "\u00fd" },
      { title: t("y - diaeresis"), character: "\u00ff" },
      { title: t("y - macron"), character: "\u0233" },
      { title: t("thorn"), character: "\u00fe" },
    ]);

    plugin.addItems("Greek Letters", [
      { title: t("Uppercase Alpha"), character: "\u0391" },
      { title: t("Uppercase Beta"), character: "\u0392" },
      { title: t("Uppercase Gamma"), character: "\u0393" },
      { title: t("Uppercase Delta"), character: "\u0394" },
      { title: t("Uppercase Epsilon"), character: "\u0395" },
      { title: t("Uppercase Zeta"), character: "\u0396" },
      { title: t("Uppercase Eta"), character: "\u0397" },
      { title: t("Uppercase Theta"), character: "\u0398" },
      { title: t("Uppercase Iota"), character: "\u0399" },
      { title: t("Uppercase Kappa"), character: "\u039a" },
      { title: t("Uppercase Lambda"), character: "\u039b" },
      { title: t("Uppercase Mu"), character: "\u039c" },
      { title: t("Uppercase Nu"), character: "\u039d" },
      { title: t("Uppercase Xi"), character: "\u039e" },
      { title: t("Uppercase Omicron"), character: "\u039f" },
      { title: t("Uppercase Pi"), character: "\u03a0" },
      { title: t("Uppercase Rho"), character: "\u03a1" },
      { title: t("Uppercase Sigma"), character: "\u03a3" },
      { title: t("Uppercase Tau"), character: "\u03a4" },
      { title: t("Uppercase Upsilon"), character: "\u03a5" },
      { title: t("Uppercase Phi"), character: "\u03a6" },
      { title: t("Uppercase Chi"), character: "\u03a7" },
      { title: t("Uppercase Psi"), character: "\u03a8" },
      { title: t("Uppercase Omega"), character: "\u03a9" },
      { title: t("Lowercase Alpha"), character: "\u03b1" },
      { title: t("Lowercase Beta"), character: "\u03b2" },
      { title: t("Lowercase Gamma"), character: "\u03b3" },
      { title: t("Lowercase Delta"), character: "\u03b4" },
      { title: t("Lowercase Epsilon"), character: "\u03b5" },
      { title: t("Lowercase Zeta"), character: "\u03b6" },
      { title: t("Lowercase Eta"), character: "\u03b7" },
      { title: t("Lowercase Theta"), character: "\u03b8" },
      { title: t("Lowercase Iota"), character: "\u03b9" },
      { title: t("Lowercase Kappa"), character: "\u03ba" },
      { title: t("Lowercase Lambda"), character: "\u03bb" },
      { title: t("Lowercase Mu/Micro"), character: "\u03bc" },
      { title: t("Lowercase Nu"), character: "\u03bd" },
      { title: t("Lowercase Xi"), character: "\u03be" },
      { title: t("Lowercase Omicron"), character: "\u03bf" },
      { title: t("Lowercase Pi"), character: "\u03c0" },
      { title: t("Lowercase Rho"), character: "\u03c1" },
      { title: t("Lowercase Final sigma"), character: "\u03c2" },
      { title: t("Lowercase Sigma"), character: "\u03c3" },
      { title: t("Lowercase Tau"), character: "\u03c4" },
      { title: t("Lowercase Upsilon"), character: "\u03c5" },
      { title: t("Lowercase Phi"), character: "\u03c6" },
      { title: t("Lowercase Chi"), character: "\u03c7" },
      { title: t("Lowercase Psi"), character: "\u03c8" },
      { title: t("Lowercase Omega"), character: "\u03c9" },
    ]);

    plugin.addItems("Miscellaneous", [
      { title: t("Cent sign"), character: "\u00a2" },
      { title: t("Euro sign"), character: "\u20ac" },
      { title: t("Pound/Sterling sign"), character: "\u00a3" },
      { title: t("Yen sign"), character: "\u00a5" },
      { title: t("Registered sign"), character: "\u00ae" },
      { title: t("Trade mark sign"), character: "\u2122" },
      { title: t("Black spade suit"), character: "\u2660" },
      { title: t("Black club suit"), character: "\u2663" },
      { title: t("Black heart suit"), character: "\u2665" },
      { title: t("Black diamond suit"), character: "\u2666" },
      { title: t("Left-to-right mark"), character: "\u200e" },
      { title: t("Right-to-left mark"), character: "\u200f" },
      { title: t("Single low-9 quotation mark"), character: "\u201a" },
      { title: t("Double low-9 quotation mark"), character: "\u201e" },
      { title: t("Macron"), character: "\u00af" },
      { title: t("Overline"), character: "\u203e" },
      { title: t("Currency Sign"), character: "\u00a4" },
      { title: t("Broken bar"), character: "\u00a6" },
      { title: t("Diaeresis"), character: "\u00a8" },
      { title: t("Inverted exclamation mark"), character: "\u00a1" },
      { title: t("Turned question mark"), character: "\u00bf" },
      { title: t("Per mille sign"), character: "\u2030" },
      { title: t("Bullet"), character: "\u2022" },
      { title: t("Three dot leader"), character: "\u2026" },
      { title: t("Minutes/feet"), character: "\u2032" },
      { title: t("Seconds/inches"), character: "\u2033" },
      { title: t("Section sign"), character: "\u00a7" },
      { title: t("Paragraph sign"), character: "\u00b6" },
      { title: t("Sharp S / ess-zed"), character: "\u00df" },
      { title: t("Single left-pointing angle"), character: "\u2039" },
      { title: t("Single right-pointing angle"), character: "\u203a" },
      { title: t("Left pointing guillemet"), character: "\u00ab" },
      { title: t("Right pointing guillemet"), character: "\u00bb" },
    ]);
  }
}
